import React, { useEffect, useState } from 'react';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';
import moment from "moment";
import { trainingApi, timesheetApi } from '../../services';
import { utitService } from '../../services/util';
import { Util } from '../../services';
// import { Rating } from 'primereact/rating';
import properties from '../../config/environmentProperties';
import { useFormik } from "formik";
import { toast } from "react-toastify";
import TrainingValidationForm from './training-validation-form';
import TrainingFeedbackForm from './training-feedback-form';
import TeamTrainingUserDetailsView from './team-training-user-details-view';
import UserRatingDetailView from './user-rating-detail-view';
import { confirmDialog } from "primereact/confirmdialog";
import TrfDetailsView from './trf-details-view';
import { Editor } from 'primereact/editor';
// import { InputText } from "primereact/inputtext";
import { Dropdown } from "primereact/dropdown";
// import { Calendar } from "primereact/calendar";
import EditEmpTrfForm from './update-emp-trf-from';
import { AutoComplete } from "primereact/autocomplete";
import { skillService } from "../../services/profile";

const TeamTraining = () => {
    const [trainingHistory, setTrainingHistory] = useState([]);
    const [empDetailDialog, setEmpDetailDialog] = useState(false);
    const [validationDialog, setValidationDialog] = useState(false);
    const [feedbackDialog, setFeedbackDialog] = useState(false);
    const [activeRecord, setActiveRecord] = useState({});
    const [activeBadgeCount, setActiveBadgeCount] = useState();
    const [tab, setTab] = useState('Approvals');
    const [approvals, setApprovals] = useState([]);
    const [validations, setValidations] = useState([]);
    const [teamSkills, setTeamSkills] = useState([]);
    const [selectedOption, setSelectedOption] = useState(null);
    const { currentEnvironment } = properties;
    const storedUser = localStorage.getItem("user");
    const [ratingTableStatus, setRatingTableStatus] = useState(false);
    const [clickedRowData, setClickedRowData] = useState({});
    const [userApprovalsData, setUserApprovalsData] = useState({});
    const [detailsViewStatus, setdetailsViewStatus] = useState(false);
    const [activeTRF, setActiveTRF] = useState({});
    const [rejectDialog, setRejectDialog] = useState(false);
    const [isValid, setIsValid] = useState(false);
    const [feedbackApprovalStatus, setFeedbackApprovalStatus] = useState(true);
    const [feedbackRejectedStatus, setFeedbackRejectedStatus] = useState(true);
    const [feedback, setFeedback] = useState("");


    const [editTrfDialog, setEditTrfDialog] = useState(false);
    const [editTrfDetails, setEditTrfDetails] = useState({});
    const [selectedTrfForApproval, setSelectedTrfForApproval] = useState([]);
    const [selectedTrfForValidation, setSelectedTrfForValidation] = useState([]);
    const [appovalDialog, setAppovalDialog] = useState(false);
    const [trainingCategory, setTrainingCategory] = useState([]);
    const [filteredSkill, setFilteredSkill] = useState(null);
    const [skillList, setSkillList] = useState([]);
    const [filteredTrainingCategory, setFilteredTrainingCategory] = useState(null);
    const [filterSkill, setFilterSkill] = useState(null);
    const [selectedFeedbackType, setSelectedFeedbackType] = useState(0);

    const searchSkill = (event) => {
        setTimeout(() => {
            let _filteredSkill;
            if (!event.query.trim().length) {
                _filteredSkill = [...skillList];
            } else {
                _filteredSkill = skillList.filter((p) => {
                    if (p.title !== null) {
                        return p.title.toLowerCase().startsWith(event.query.toLowerCase());
                    }
                });
            }
            setFilteredSkill(_filteredSkill);
        }, 250);
    };

    const formik = useFormik({
        initialValues: {
            employeename: '',
            expectedOutcome: '',
        },
        validate: (data) => {
            let errors = {};
            return errors;
        },
        onSubmit: (data) => {
            // save(data);
        },
    });

    useEffect(() => {
        getHistory();
        getManagerUserInfo({ pageNum: 0, pageSize: 400 });
        getApprovals();
        // if (storedUser) {
        //     var data = JSON.parse(storedUser);
        //     fetchValidationsData(data?.id)
        // }
        fetchCategories();
        fetchSkillsList();
    }, []);

    const fetchSkillsList = () => {
        skillService.getSkills().then((resp) => {
            setSkillList(resp.data.data);
        });
    };

    const fetchCategories = () => {
        trainingApi.fetchTrainingCategoryList().then((resp) => {
            setTrainingCategory(resp.data.data);
        });
    };

    // const fetchValidationsData = (id) => {
    //     trainingApi.getTrfValidationHistory().then((resp) => {
    //         console.log(resp.data.data, "fetchValidationsDatafetchValidationsData")
    //         setValidations(resp.data.data);
    //     }).catch((e) => { });
    // };

    const getApprovals = () => {
        trainingApi.fetchTrainingApprovals().then(resp => {
            setUserApprovalsData(resp?.data?.data);
            const formattedData = resp.data.data.flatMap(user => {
                return user.TrainingRequisitionForms.map(training => ({
                    userId: user.id,
                    ecn: user.ecn,
                    email: user.email,
                    name: `${user.firstName} ${user.lastName}`,
                    id: training.id,
                    startDate: training.trainingRequisitionDate,
                    trainingType: training.trainingType || '',
                    trainingLearning: training.currentTechnology || 'N/A',
                    categoryOfTraining: training.categoryOfTrainings?.id || 'N/A',
                    categoryOfTrainings: training.categoryOfTrainings || 'N/A',
                    categoryOfTrainingName: training.categoryOfTrainings?.title || 'N/A',
                    targetSkills: training.targetSkills?.title || 'N/A',
                    currentLevel: training.currentLevel || 'N/A',
                    expectedLevel: training.expectedLevel || 'N/A',
                    trainingRequisitionDate: training.trainingRequisitionDate,
                    startDateOfTraining: training.startDateOfTraining,
                    endDateOfTraining: training.endDateOfTraining,
                    improvementAreaTriggeringTrainingNeed: training.improvementAreaTriggeringTrainingNeed,
                    moduleSpecificDetails: training.moduleSpecificDetails,
                    purposeOfRequestedTraining: training.purposeOfRequestedTraining,
                    businessoutcomeDetails: training.businessoutcomeDetails,
                    status: training.status
                }));
            });
            console.log(formattedData, "formattedData")
            // let formattedDataArr = formattedData?.filter((item) => (item.status === 2 || item.status === 4));
            let formattedDataArr = formattedData?.filter((item) => (item.status === 1));
            setApprovals(formattedDataArr);
        }).catch(e => {
            console.error('Error fetching approvals:', e);
        });
    };
    // useEffect(() => {
    //     if (tab === 'Approvals') {
    //         getApprovals();
    //     }
    // }, [tab]);
    const getManagerUserInfo = (param = {}) => {
        timesheetApi.getUsersBySuperior(param).then((resp) => {
            try {
                // setEmployeeList(resp?.data?.data);
                if (resp?.data?.data.length > 0) {
                    const data = resp?.data?.data;
                    const transformedData = data.map((user) => ({
                        ...user,
                        name: `${user.firstName} ${user.lastName}`.trim(),
                    }));
                    setTeamSkills(transformedData);
                }
            } catch (error) {
                // Error handle
            }
        });
    };

    const getHistory = () => {
        trainingApi.fetchTeamTrainings().then(resp => {
            setTrainingHistory(resp.data.data);
            setValidations(resp.data.data);
            const activeBadge = resp?.data?.data.filter((el) => {
                return !el.isManagerValidate || !el.isManagerFeedback;
            });
            setActiveBadgeCount(activeBadge.length);
        }).catch(e => {
        })
    }

    /* For View Trf Details of Rsource */
    const viewTrfDetails = (rowData) => {
        const result = userApprovalsData.flatMap(item => item.TrainingRequisitionForms);
        const finalResult = result.find(item => item.id === rowData.id);
        setClickedRowData(finalResult);
        setdetailsViewStatus(true);
    }
    /* For View Trf Details of Rsource */
    /* Reload After Close Dialog */
    const reloadTrfHistory = () => {
        setdetailsViewStatus(false);
        getApprovals();
    }
    /* Reload After Close Dialog */

    /* Update Trf Details by Manager */
    const editTrfDetailsForm = (rowData) => {
        setEditTrfDetails(rowData);
        setEditTrfDialog(true);
    }

    const reload = () => {
        setSelectedTrfForApproval([]);
        setEditTrfDialog(false);
        setAppovalDialog(false);
        getApprovals();
    }

    const editTrfDetailsDialog = () => {
        return (<>
            <Dialog header="TRF Approvals" visible={editTrfDialog} className='full_dialog' onHide={() => { setEditTrfDialog(false); setIsValid(false); setFeedback(''); }}>
                <EditEmpTrfForm reload={reload} userTrfDetail={editTrfDetails} type={0} />
            </Dialog>
        </>)
    }
    /* Update Trf Details by Manager */

    const actionBody = (rowData) => {
        return (<>
            {/* <Button title="View TRF Form" icon="pi pi-eye" className="p-button-rounded p-button-text" severity="secondary" onClick={() => viewTrfDetails(rowData)} /> */}
            <Button icon="pi pi-eye" className="p-button-rounded p-button-text" severity="secondary" title="View & Update TRF Form" tooltipOptions={{ position: 'top' }} onClick={(e) => editTrfDetailsForm(rowData)} />
            {/* <Button icon="pi pi-check" className="p-button-rounded p-button-text" severity="success" tooltip='Approve' tooltipOptions={{ position: 'top' }} onClick={(e) => approveRejectEmpTRFRecord(e, rowData, 'approve')} /> */}
            {/* <Button icon="pi pi-times" className="p-button-rounded p-button-text" severity="danger" tooltip='Reject' tooltipOptions={{ position: 'top' }} onClick={(e) => approveRejectEmpTRFRecord(e, rowData, 'reject')} /> */}
            {/* <Button icon="pi pi-times" className="p-button-rounded p-button-text" severity="danger" tooltip='Reject' onClick={() => rejectionForm(rowData)} tooltipOptions={{ position: 'top' }} /> */}
        </>)
    }


    // const rejectionForm = (r) => {
    //     setActiveTRF(r);
    //     setRejectDialog(true);
    // }

    const renderHeader = () => {
        return (
            <span className="ql-formats">
                <button className="ql-bold" aria-label="Bold"></button>
                <button className="ql-italic" aria-label="Italic"></button>
                <button className="ql-underline" aria-label="Underline"></button>
            </span>
        );
    }

    const isCommentCheck = (val, type) => {
        if (type === "Rejection") {
            if (val) {
                setFeedbackRejectedStatus(true);
                setIsValid(true);
            } else {
                setFeedbackRejectedStatus(false);
                setIsValid(false);
            }
        }
    }


    const approvalDialog = () => {
        return (<>
            <Dialog header="TRF Approvals" visible={appovalDialog} className='full_dialog' onHide={() => { setAppovalDialog(false); setIsValid(false); setFeedback(''); }}>
                <EditEmpTrfForm reload={reload} userTrfDetail={selectedTrfForApproval[0]} type={1} userDetails={selectedTrfForApproval} />
            </Dialog>
        </>)
    }

    const rejectionDialog = () => {
        return (<>
            <Dialog header="TRF Rejection" visible={rejectDialog} style={{ width: '700px' }} onHide={() => { setRejectDialog(false); setIsValid(false); }}>
                <div>
                    <h2>{activeTRF?.nameOfNominatedParticipant}</h2>
                    <div className="flex flex-wrap p-field font-bold block">
                        <div className="col-12">
                            <label htmlFor="feedback" className="font-bold block mb-2 training-heading mt-2" >Rejection Note :</label>
                            {/* <InputText name="comments" placeholder="Provide feedback" required style={{ background: "white" }} className="w-full" /> */}
                            <Editor headerTemplate={renderHeader} style={{ height: '200px' }} placeholder="Rejection Note" value={feedback} onTextChange={(e) => { setFeedback(e.htmlValue ? e.htmlValue : ''); isCommentCheck(e.htmlValue, "Rejection") }} />
                        </div>
                        {!feedbackRejectedStatus && (<span style={{ color: 'red' }}>Rejection Note is Required!</span>)}
                    </div>
                </div>

                <hr />
                <div className='' style={{ textAlign: 'right' }}>
                    {/* <Button label='Reject' icon='pi pi-check' severity='primary' className='mr-1' onClick={() => handleSubmit("Rejection")} /> */}
                    <Button label='Reject' icon='pi pi-check' severity='primary' className='mr-1' onClick={() => handleTrfApproval("Rejection")} />
                    <Button label='Cancel' icon='pi pi-times' severity='secondary' onClick={() => { setRejectDialog(false); setIsValid(false); setFeedback(''); }} />
                </div>
            </Dialog>
        </>)
    }

    const handleSubmit = (status) => {
        if (status === "Rejection" && feedback == '') {
            setFeedbackRejectedStatus(false);
            setIsValid(false);
        } else {
            setFeedbackRejectedStatus(true);
            setIsValid(true);
        }
        var dataObj = [
            {
                status: 3,
                training: activeTRF?.id,
            },
        ];
        try {
            if (isValid) {
                trainingApi.updateApproveRejectTrainingForm(dataObj).then(
                    (resp) => {
                        toast.success(resp?.data?.message);
                        setRejectDialog(false);
                        setTimeout(() => {
                            getApprovals();
                        }, 1000);
                    },
                    (err) => {
                        toast.error(err.response.data.error);
                    }
                );
            }
        } catch (error) {
            toast.error("Unable to update");
        }
    };

    /* Delete Trf Record Start */
    const approveRejectEmpTRFRecord = (e, rowData, type) => {
        confirmDialog({
            target: e.currentTarget,
            message: `Are you sure you want to ${type} this record?`,
            header: 'Action Confirmation',
            icon: 'pi pi-info-circle',
            acceptClassName: "p-button-danger",
            acceptLabel: 'No',
            rejectLabel: 'Yes',
            reject: () => {
                var dataObj = [
                    {
                        status: type === "approve" ? 2 : 3,
                        training: rowData?.id,
                    },
                ];
                try {
                    trainingApi.updateApproveRejectTrainingForm(dataObj).then(
                        (resp) => {
                            toast.success(resp?.data?.message);
                            getApprovals();
                        },
                        (err) => {
                            toast.error(err.response.data.error);
                        }
                    );
                } catch (error) {
                    toast.error("Unable to delete");
                }
            },
            accept: () => { }
        });
    }
    /* Delete Trf Record End */

    const resourceNameBody = (data, o) => {
        return (<div className='grid ess-resource'>
            <div className='col-fixed image' >
                <img src={currentEnvironment.docPath + 'images/' + data?.user?.photo} alt={data.firstName} style={{ verticalAlign: 'middle' }}
                    tag={currentEnvironment.docPath + 'images/' + data.photo}
                    onError={(e) => { e.target.src = '/assets/images/avtar.png' }} />
            </div>
            <div className='col label'>
                <h2 className='m-0'>{data.firstName} {data.lastName} <small>( ECN: <strong>{data.ecn}</strong> )</small></h2>
            </div>
        </div>)
    }

    const closeValidationTrainingDialog = () => {
        setValidationDialog(false);
        setSelectedTrfForValidation([]);
    }
    const closeFeedbackTrainingDialog = () => {
        setFeedbackDialog(false);
    }

    const refreshTeamTrainingData = () => {
        setValidationDialog(false);
        setFeedbackDialog(false);
        setEmpDetailDialog(false);
        getHistory();
        // if (storedUser) {
        //     var data = JSON.parse(storedUser);
        //     fetchValidationsData(data?.id)
        // }
    }

    const validateTrainingPopup = (rowData, type) => {
        setSelectedFeedbackType(type);
        setActiveRecord(rowData);
        setValidationDialog(true);
    }

    const effectivenessFeedbackPopup = (rowData, type) => {
        setSelectedFeedbackType(type);
        setActiveRecord(rowData);
        setFeedbackDialog(true);
    }

    const viewEmpTrainingDetail = (rowData) => {
        setActiveRecord(rowData);
        // setActiveRecord(rowData);
        setEmpDetailDialog(true);
    }


    const actionColumn = (rowData) => {
        return (<>
            {/* <Button icon="pi pi-check-circle" className="p-button-rounded p-button-text" severity="secondary" tooltip='Validate' onClick={() => validateTrainingPopup(rowData, 0)} tooltipOptions={{ position: 'top' }} disabled={(rowData?.trainingType === 'Instructor-Led' && !rowData?.isManagerValidate && rowData?.is_assesment_completed && rowData?.is_feedback_completed) || (rowData?.trainingType === 'Self-Paced' && !rowData?.isManagerValidate && rowData?.is_feedback_completed) ? false : true} />
            <Button icon="pi pi-file-edit" className="p-button-rounded p-button-text" severity="secondary" tooltip='Feedback' onClick={() => effectivenessFeedbackPopup(rowData, 0)} tooltipOptions={{ position: 'top' }} disabled={(rowData?.trainingType === 'Instructor-Led' && rowData?.isManagerValidate && rowData?.is_assesment_completed && rowData?.is_feedback_completed && !rowData?.isManagerFeedback) || (rowData?.trainingType === 'Self-Paced' && rowData?.isManagerValidate && rowData?.is_feedback_completed && !rowData?.isManagerFeedback) ? false : true} /> */}
            
            {/* <Button icon="pi pi-file-edit" className="p-button-rounded p-button-text" severity="secondary" tooltip='Feedback' onClick={() => effectivenessFeedbackPopup(rowData, 0)} tooltipOptions={{ position: 'top' }} disabled={(rowData?.trainingType === 'Instructor-Led' && rowData?.is_assesment_completed && rowData?.is_feedback_completed && !rowData?.isManagerFeedback) || (rowData?.trainingType === 'Self-Paced' && rowData?.isManagerValidate && rowData?.is_feedback_completed && !rowData?.isManagerFeedback) ? false : true}/> */}

            <Button icon="pi pi-file-edit" className="p-button-rounded p-button-text" severity="secondary" tooltip='Feedback' onClick={() => effectivenessFeedbackPopup(rowData, 0)} tooltipOptions={{ position: 'top' }} disabled={(rowData?.trainingType === 'Instructor-Led' && rowData?.is_assesment_completed && rowData?.is_feedback_completed && !rowData?.isManagerFeedback) || (rowData?.trainingType === 'Self-Paced' && rowData?.is_feedback_completed && !rowData?.isManagerFeedback) ? false : true}/>
        </>)
    }

    const renderValidationDialog = () => {
        return (<>
            <Dialog header="Trainig Validation" visible={validationDialog} style={{ width: '700px' }} onHide={() => setValidationDialog(false)}>
                <TrainingValidationForm validationData={selectedFeedbackType === 0 ? activeRecord : selectedTrfForValidation} closeDialoge={closeValidationTrainingDialog} reload={refreshTeamTrainingData} type="normal" selectedFeedbackType={selectedFeedbackType} />
            </Dialog>
        </>)
    }

    const renderFeedbackDialog = () => {
        return (<>
            <Dialog header="Training Effectiveness Feedback" visible={feedbackDialog} style={{ width: '700px' }} onHide={() => setFeedbackDialog(false)}>
                <TrainingFeedbackForm feedbackData={selectedFeedbackType === 0 ? activeRecord : selectedTrfForValidation} closeDialoge={closeFeedbackTrainingDialog} reload={refreshTeamTrainingData} type="normal" selectedFeedbackType={selectedFeedbackType} />
            </Dialog>
        </>)
    }

    const renderUserSkillDialog = () => {
        return (<>
            <Dialog className='custom_popup' header="User Skill Rating" visible={ratingTableStatus} onHide={() => setRatingTableStatus(false)} style={{ width: '80vw' }}>
                <UserRatingDetailView clickedRowData={activeRecord} />
            </Dialog>
        </>)
    }


    const validationBodyTemp = (rowData, type) => {
        switch (type) {
            case 'nameOfNominatedParticipant':
                return rowData?.userDetails?.firstName + ' ' + rowData?.userDetails?.lastName;
            case 'projectName':
                return rowData?.projectName;
            case 'category':
                return <span className='capitalize'>{rowData?.categoryOfTrainings?.title}</span>;
            case 'targetSkills':
                return <span className='capitalize'>{rowData?.targetSkills?.title}</span>;
            // case 'currentTechnology':
            // return rowData?.TrainingDetails[0]?.currentTechnology;
            case 'startDate':
                return moment(rowData?.startDate).format('DD-MM-YYYY');
            case 'endDate':
                return moment(rowData?.endDate).format('DD-MM-YYYY');
            default:
                return;
        }
    }

    const validationBodyTemp1 = (rowData, type) => {
        switch (type) {
            case 'nameOfNominatedParticipant':
                return rowData.firstName + ' ' + rowData.lastName;
            case 'projectName':
                return rowData?.TrainingDetails[0]?.projectName;
            case 'category':
                return <span className='capitalize'>{rowData?.TrainingDetails[0]?.categoryOfTrainings?.title}</span>;
            case 'targetSkills':
                return <span className='capitalize'>{rowData?.TrainingDetails[0]?.targetSkills?.title}</span>;
            // case 'currentTechnology':
            // return rowData?.TrainingDetails[0]?.currentTechnology;
            case 'startDate':
                return moment(rowData?.TrainingDetails[0]?.startDate).format('DD-MM-YYYY');
            case 'endDate':
                return moment(rowData?.TrainingDetails[0]?.endDate).format('DD-MM-YYYY');
            default:
                return;
        }
    }

    const skillStatusBody = (rowData) => {
        return (
            <>{rowData.status === 1 ? 'Active' : 'InActive'}</>
        );
    }

    const skillActionBody = (rowData) => {
        return (<>
            <Button icon="pi pi-eye" title='View Resource Skills' className="p-button-rounded p-button-text" severity="secondary" onClick={() => viewSkillRatingList(rowData)} />
        </>)
    }

    const viewSkillRatingList = (rowData) => {
        setActiveRecord(rowData);
        setRatingTableStatus(true);
    }

    const selectMultiTrf = (e) => {
        setSelectedTrfForApproval(e.value);
    };

    const selectMultiTrfValidation = (e) => {
        setSelectedTrfForValidation(e.value);
    }


    const isManagerValidate = (rowData) => {
        console.log(rowData, "rowDatarowData")
        return (
            rowData?.trainingDetailStatus === 2 &&
            (
                // Case 1: Instructor-Led (no assessment, no feedback)
                (rowData?.trainingType === 'Instructor-Led' &&
                    !rowData?.isManagerValidate && rowData?.is_assesment_completed && rowData?.is_feedback_completed) ||

                // Case 2: Self-Paced (no assessment, no feedback)
                (rowData?.trainingType === 'Self-Paced' &&
                    !rowData?.isManagerValidate && rowData?.is_feedback_completed)
            )
        );
    };

    const validateAllAssesmentForm = () => {
        if (selectedTrfForValidation.length === 0) {
            toast.error("Please select atleast one record");
            return;
        }
        const allValidated = selectedTrfForValidation.every((row) => isManagerValidate(row));
        if (!allValidated) {
            toast.error("Some of selected records are not eligible to validate.");
            return;
        }

        //Matched Same Records for Approvals
        const firstCategory = selectedTrfForValidation[0].categoryOfTraining;
        const firstSkill = selectedTrfForValidation[0].targetSkill;

        const allSame = selectedTrfForValidation.every(item =>
            item.categoryOfTraining === firstCategory && item.targetSkill === firstSkill
        );
        if (!allSame) {
            toast.error("Error: categoryOfTraining or targetSkills do not match in all records.");
            return;
        }
        validateTrainingPopup(selectedTrfForValidation, 1);
    }

    const isManagerEffectiveFeedback = (rowData) => {
        return (
            rowData?.trainingDetailStatus === 2 &&
            (
                // Case 1: Instructor-Led (no assessment, no feedback)
                (rowData?.trainingType === 'Instructor-Led' && rowData?.isManagerValidate && rowData?.is_assesment_completed && rowData?.is_feedback_completed && !rowData?.isManagerFeedback) ||

                // Case 2: Self-Paced (no assessment, no feedback)
                (rowData?.trainingType === 'Self-Paced' && rowData?.isManagerValidate && rowData?.is_feedback_completed && !rowData?.isManagerFeedback)
            )
        );
    };
    const validateAllFeedbackForm = () => {
        console.log(selectedTrfForValidation, "selectedTrfForValidationselectedTrfForValidation")
        if (selectedTrfForValidation.length === 0) {
            toast.error("Please select atleast one record");
            return;
        }
        // const allEffectiveFeedback = selectedTrfForValidation.every((row) => isManagerEffectiveFeedback(row));
        // if (!allEffectiveFeedback) {
        //     toast.error("Feedback can only be after validated training!");
        //     return;
        // }

        //Matched Same Records for Approvals
        const firstCategory = selectedTrfForValidation[0].categoryOfTraining;
        const firstSkill = selectedTrfForValidation[0].targetSkill;

        const allSame = selectedTrfForValidation.every(item =>
            item.categoryOfTraining === firstCategory && item.targetSkill === firstSkill
        );
        if (!allSame) {
            toast.error("Error: categoryOfTraining or targetSkills do not match in all records.");
            return;
        }

        const isFeedbackCompleted = selectedTrfForValidation.every(item =>
            item.is_feedback_completed && !item.isManagerFeedback
        );
        if (!isFeedbackCompleted) {
            toast.error("Error: Select records should be feedback completed! Select active action records.");
            return;
        }

        effectivenessFeedbackPopup(selectedTrfForValidation, 1)
    }

    const approveRejectSelectedTrf = (type) => {
        if (selectedTrfForApproval.length === 0) {
            toast.error("Please select atleast one TRF");
            return;
        }
        //Matched Same Records for Approvals
        const firstCategory = selectedTrfForApproval[0].categoryOfTraining;
        const firstSkill = selectedTrfForApproval[0].targetSkills;

        const allSame = selectedTrfForApproval.every(item =>
            item.categoryOfTraining === firstCategory && item.targetSkills === firstSkill
        );
        if (!allSame) {
            toast.error("Error: categoryOfTraining or targetSkills do not match in all records.");
            return;
        }

        const hasStatusApprovedByManager = selectedTrfForApproval.some(item => (item.status === 2 || item.status === 5));
        if (hasStatusApprovedByManager) {
            toast.error("Error: One or more selected records already have approved");
            return;
        }

        if (type === '1') {
            setAppovalDialog(true);
        }
        if (type === '2') {
            setRejectDialog(true);
        }
    }


    const handleTrfApproval = (status) => {
        if (status === "Approved" && feedback == '') {
            setFeedbackApprovalStatus(false);
            setIsValid(false);
        } else {
            setFeedbackApprovalStatus(true);
            setIsValid(true);
        }
        if (status === "Rejection" && feedback == '') {
            setFeedbackRejectedStatus(false);
            setIsValid(false);
        } else {
            setFeedbackRejectedStatus(true);
            setIsValid(true);
        }
        var dataObj = {
            trainingId: selectedTrfForApproval.map(item => item.id),
            comments: Util.removeHtmlTags(feedback),
            isApproved: status === "Approved" ? true : false,
            // status: status === "Approved" ? 2 : 3,
        };
        try {
            if (isValid) {
                trainingApi.updateApproveRejectMultiTrainingForm(dataObj).then(
                    (resp) => {
                        toast.success(resp?.data?.messages[0]);
                        setAppovalDialog(false);
                        setRejectDialog(false);
                        setFeedbackDialog(false);
                        setTimeout(() => {
                            getHistory();
                            getManagerUserInfo({ pageNum: 0, pageSize: 400 });
                            getApprovals();
                        }, 1000);
                    },
                    (err) => {
                        toast.error(err.response.data.error);
                    }
                );
            }
        } catch (error) {
            toast.error("Unable to update");
        }
    };

    const clearFilterdata = () => {
        setFilteredTrainingCategory(null);
        setFilterSkill(null);
        getApprovals();
        getHistory();
    }

    const filterUserTraining = () => {
        if (!filteredTrainingCategory || !filterSkill?.title) {
            // Show some validation message
            alert("Please select both Training Category and Skill to search.");
            return;
        }
        let param = {
            skill: filterSkill?.title || '',
            category: filteredTrainingCategory,
        };
        if (tab === "Approvals") {
            trainingApi.filterTrfBySkill(param).then((resp) => {
                console.log(resp?.data?.data, "resp?.data?.dataresp?.data?.data", resp)
                setUserApprovalsData(resp?.data?.data);
                const formattedData = resp.data.data.flatMap(user => {
                    return user.TrainingRequisitionForms.map(training => ({
                        userId: user.id,
                        ecn: user.ecn,
                        email: user.email,
                        name: `${user.firstName} ${user.lastName}`,
                        id: training.id,
                        startDate: training.trainingRequisitionDate,
                        trainingType: training.trainingType || '',
                        trainingLearning: training.currentTechnology || 'N/A',
                        categoryOfTraining: training.categoryOfTrainings?.id || 'N/A',
                        categoryOfTrainings: training.categoryOfTrainings || 'N/A',
                        categoryOfTrainingName: training.categoryOfTrainings?.title || 'N/A',
                        targetSkills: training.targetSkills?.title || 'N/A',
                        currentLevel: training.currentLevel || 'N/A',
                        expectedLevel: training.expectedLevel || 'N/A',
                        trainingRequisitionDate: training.trainingRequisitionDate,
                        startDateOfTraining: training.startDateOfTraining,
                        endDateOfTraining: training.endDateOfTraining,
                        improvementAreaTriggeringTrainingNeed: training.improvementAreaTriggeringTrainingNeed,
                        moduleSpecificDetails: training.moduleSpecificDetails,
                        purposeOfRequestedTraining: training.purposeOfRequestedTraining,
                        businessoutcomeDetails: training.businessoutcomeDetails,
                        status: training.status
                    }));
                });
                let finalDataArr = formattedData?.filter((item) => item.status === 1);
                setApprovals(finalDataArr);
                // setSkillList(resp.data.data);
            });
        }

        if (tab === "Validate") {
            trainingApi.filterTrfBySkill(param).then((resp) => {
                // const activeBadge = resp?.data?.data?.TrainingDetails.filter((el) => {
                //     return !el.isManagerValidate || !el.isManagerFeedback;
                // });
                // setActiveBadgeCount(activeBadge.length);
                const formattedData = resp.data.data.flatMap(item => {
                    return item.TrainingDetails;
                });
                // const activeBadge = formattedData.filter((el) => {
                //     return !el.isManagerValidate || !el.isManagerFeedback;
                // });
                // setActiveBadgeCount(activeBadge.length);
                setValidations(formattedData);
            });
        }

    }

    return (
        <div className='ess-page'>
            <div className="formgrid grid mt-2">
                <div className="field col-12 md:col-5">
                    <div className='mb-2'>
                        <Button label="Approvals" className={tab === "Approvals" ? 'p-button-primary' : 'p-button-outlined p-button-inactive'} onClick={() => setTab('Approvals')} badge={approvals.length} badgeClassName="p-badge-danger" />
                        <Button label="Training Validation" className={tab === "Validate" ? 'p-button-primary' : 'p-button-outlined p-button-inactive'} onClick={() => setTab('Validate')} badge={activeBadgeCount} badgeClassName="p-badge-danger" />
                        <Button label="Team Skills" className={tab === "TeamSkills" ? 'p-button-primary' : 'p-button-outlined p-button-inactive'} onClick={() => setTab('TeamSkills')} />
                    </div>
                </div>
                {(tab === "Approvals" || tab === "Validate") && (
                    <div className="field col-12 md:col-7 mb-2">
                        <div className="formgrid grid training_head">
                            <div className="field col-4">
                                <Dropdown name="trainingCategory" value={filteredTrainingCategory} onChange={(e) => setFilteredTrainingCategory(e.value)} options={trainingCategory} optionLabel="title" optionValue="title" placeholder="Select a Category" className="w-full" />
                            </div>
                            <div className="field col-4">
                                <AutoComplete
                                    value={filterSkill}
                                    suggestions={filteredSkill}
                                    completeMethod={searchSkill}
                                    field="title"
                                    name="targetSkill"
                                    // multiple
                                    virtualScrollerOptions={{ itemSize: 38 }}
                                    onChange={(e) => setFilterSkill(e.value)}
                                    placeholder="Filter By Skill"
                                    aria-label="Skills"
                                    dropdownAriaLabel="Select Skills"
                                    className="w-full"
                                    style={{maxWidth: '100%'}}
                                />
                            </div>
                            <div className="field col-4 mb-0">
                                <Button label="Filter" className="p-button-rounded  mr-2 mb-2" icon="pi pi-search" type="button" onClick={filterUserTraining} />
                                <Button label="Clear" className="p-button-rounded mb-2" icon="pi pi-times" type="button" onClick={clearFilterdata} />
                            </div>
                        </div>
                    </div>
                )}
            </div>

            <div className='ess-table bordered-wrapper'>
                {tab === "Approvals" && <div>
                    <DataTable value={approvals} stripedRows responsiveLayout="scroll"
                        paginator
                        paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
                        currentPageReportTemplate="Showing {first} to {last} of {totalRecords}" rows={10} rowsPerPageOptions={[10, 20, 50]}
                        selection={selectedTrfForApproval}
                        onSelectionChange={(e) => selectMultiTrf(e)}
                    >
                        <Column selectionMode="multiple" headerStyle={{ width: "8rem" }}></Column>
                        <Column field="id" header="Training Req. ID" body={(r) => r?.id.toString().padStart(7, '0')}></Column>
                        <Column field="ecn" header="ECN" />
                        <Column field="name" header="Name" />
                        <Column field="categoryOfTraining" header="Category" body={(r) => <span className='capitalize'>{r?.categoryOfTrainingName}</span>}></Column>
                        <Column field="targetSkills" header="Target Skill"></Column>
                        <Column field="" header="Requisition Date" body={(r) => (utitService.dateWithMonthConverter(r?.trainingRequisitionDate))}></Column>
                        {/* <Column field="createdAt" header="Start Date" body={(r) => (utitService.dateWithMonthConverter(r.endDateOfTraining))}></Column>
                        <Column field="updatedAt" header="End Date" body={(r) => (utitService.dateWithMonthConverter(r.endDateOfTraining))}></Column> */}
                        <Column field="status" header="Status" body={(rowData) => (utitService.getTrainingStatus(rowData?.status))} ></Column>
                        <Column header="Actions" style={{ width: '150px', textAlign: 'center' }} body={actionBody} />
                    </DataTable>
                    <div className="formgrid grid mt-2">
                        <div className="field col-12">
                            <Button label="Approve All" icon="pi pi-check" className="p-button-rounded" onClick={() => approveRejectSelectedTrf('1')} />
                            <Button label="Reject All" icon="pi pi-times" className="p-button-rounded ml-2" onClick={() => approveRejectSelectedTrf('2')} />
                        </div>
                    </div>
                    <Dialog className='custom_popup' header="View TRF Details" visible={detailsViewStatus} onHide={() => reloadTrfHistory()} style={{ width: '80vw' }}>
                        <TrfDetailsView clickedRowData={clickedRowData} />
                    </Dialog>
                    {/* View Trf Fprm details end*/}
                </div>}
                {tab === "Validate" && <div>
                    <DataTable value={validations} stripedRows responsiveLayout="scroll"
                        paginator
                        paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
                        currentPageReportTemplate="Showing {first} to {last} of {totalRecords}" rows={10} rowsPerPageOptions={[10, 20, 50]}
                        selection={selectedTrfForValidation}
                        onSelectionChange={(e) => selectMultiTrfValidation(e)}
                    >
                        <Column selectionMode="multiple" headerStyle={{ width: "8rem" }}></Column>
                        <Column field="" header="Training ID" body={(rowData) => (<span title="View Training Detail" style={{ cursor: 'pointer', color: 'blue', }} onClick={() => viewEmpTrainingDetail(rowData)}>{rowData?.id.toString().padStart(7, '0')}</span>)}></Column>
                        <Column field="nameOfNominatedParticipant" header="Participent" body={(rowData) => validationBodyTemp(rowData, 'nameOfNominatedParticipant')}></Column>
                        <Column field="projectName" header="Project" body={(rowData) => validationBodyTemp(rowData, 'projectName')}></Column>
                        <Column field="categoryOfTraining" header="Category" body={(rowData) => validationBodyTemp(rowData, 'category')}></Column>
                        <Column field="targetSkills" header="Target Skill" body={(rowData) => validationBodyTemp(rowData, 'targetSkills')}></Column>
                        <Column field="startDateOfTraining" header="Exp. Start Date" body={(rowData) => validationBodyTemp(rowData, 'startDate')}></Column>
                        <Column field="endDateOfTraining" header="Exp. End Date" body={(rowData) => validationBodyTemp(rowData, 'endDate')}></Column>
                        <Column header="Actions" style={{ textAlign: 'center' }} body={actionColumn} />
                    </DataTable>
                    <div className="formgrid grid mt-2">
                        <div className="field col-12">
                            {/* <Button label="Validate Training" icon="pi pi-check" className="p-button-rounded" onClick={() => validateAllAssesmentForm()} /> */}
                            <Button label="Validate Feedback" icon="pi pi-check" className="p-button-rounded ml-2" onClick={() => validateAllFeedbackForm()} />
                        </div>
                    </div>
                </div>}

                {tab === "TeamSkills" && <div>
                    <DataTable value={teamSkills} stripedRows responsiveLayout="scroll"
                        paginator
                        paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
                        currentPageReportTemplate="Showing {first} to {last} of {totalRecords}" rows={10} rowsPerPageOptions={[10, 20, 50]}
                    >
                        <Column field="name" header="Resource Name" bodyStyle={resourceNameBody} ></Column>
                        <Column field="ecn" header="ECN" />
                        <Column field="Designation" header="Designation" body={(r) => r.Designation?.title}></Column>
                        {/* <Column field="createdAt" header="Start Date" body={(r) => (utitService.dateWithMonthConverter(r.createdAt))}></Column>
                        <Column field="updatedAt" header="End Date" body={(r) => (utitService.dateWithMonthConverter(r.updatedAt))}></Column> */}
                        <Column field="status" header="Status" body={skillStatusBody}></Column>
                        <Column field='' header="Action" style={{ textAlign: 'center' }} body={skillActionBody} />
                    </DataTable>
                </div>}
            </div>
            {renderValidationDialog()}
            {renderFeedbackDialog()}
            {renderUserSkillDialog()}
            {approvalDialog()}
            {rejectionDialog()}
            {editTrfDetailsDialog()}

            <Dialog className='custom_popup' header="View Training Details" visible={empDetailDialog} onHide={() => refreshTeamTrainingData()} style={{ width: '80vw' }}>
                <TeamTrainingUserDetailsView clickedRowData={activeRecord} />
            </Dialog>


        </div>
    )
}

export default TeamTraining